/**
 * External Dependencies
 */
import $ from 'jquery'
import slick from 'slick-carousel'

$(() => {

  //Main Menu open/close
  $('.menu-open').on('click', function(e) {
    $('.overlay-menu').css('width','100%');
    e.preventDefault();
  });
  $('.menu-close').on('click', function(e) {
    $('.overlay-menu').css('width','0%');
    e.preventDefault();
  });


  //Accordion
  $(".accordion-head").on('click', function(e) {
    $(".accordion-head").removeClass('accordion-head-open');
    $(this).addClass('accordion-head-open');
    if ($('.accordion-body').is(':visible')) {
      $(".accordion-body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion-body").is(':visible')) {
      $(this).next(".accordion-body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion-body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
    e.preventDefault();
  });


  //Slider partners
  $('.carosello-partners').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    dots: true,
    responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        }
      ]
  });


})
